module.exports = __webpack_public_path__ + "img/pc_banner_sup_vip.166e329e.webp";